import React, { useMemo } from 'react';
import Timer from '../../../../../../../common/Timer';
import OmnitureUtils from '../../../../../../../../../common/utils/Omniture/OmnitureUtils';

const OfferCard = ({ cardData, cardIndex, sectionIndex }) => {
  const [showTimer, isEndTime] = useMemo(() => {
    if (
      +(cardData?.sectionCardTimeData?.timerStartTime || 0) < Date.now() &&
      +(cardData?.sectionCardTimeData?.timerStartTime || 0) <
        +(cardData?.sectionCardTimeData?.endTime || 0)
    ) {
      return [
        !!cardData?.sectionCardTimeData?.timerStartTime,
        +(cardData?.sectionCardTimeData?.timerStartTime || 0) >=
          +(cardData?.sectionCardTimeData?.startTime || 0),
      ];
    }

    return [false, false];
  }, [cardData?.sectionCardTimeData]);

  const [startTime, endTime, timerStartTime] = useMemo(
    () => [
      cardData?.sectionCardTimeData?.startTime || 0,
      cardData?.sectionCardTimeData?.endTime || 0,
      cardData?.sectionCardTimeData?.timerStartTime || 0,
    ],
    [cardData]
  );

  const handleArrowClick = () => {
    OmnitureUtils.trackClickEvent({
      prop54: `inlinesection_${sectionIndex}_card_${cardIndex}_click`,
    });
    window.open(cardData?.tncUrl);
  };

  const handleTNCClick = () => {
    OmnitureUtils.trackClickEvent({
      prop54: `inlinesection_${sectionIndex}_card_${cardIndex}_click_tnc`,
    });
    window.open(cardData?.tncUrl);
  };

  return (
    <div className="offerInnerDetails">
      <div className="offerCard">
        <div className="offerContents">
          <img className="offerIcon" src={cardData?.iconUrl} alt="offer card icon" />
          <div>
            <div
              className="offerInfo marginBottom2"
              dangerouslySetInnerHTML={{ __html: cardData?.text }}
            />
            <div
              className="offerInfo marginBottom5"
              dangerouslySetInnerHTML={{ __html: cardData?.header }}
            />
            {!!cardData?.tncUrl && (
              <span onClick={handleTNCClick} className="offerTerms">
                Terms and Conditions
              </span>
            )}
          </div>
        </div>
        {!!cardData?.tncUrl && (
          <span onClick={handleArrowClick} className="icon mmt-chevron-right" />
        )}
      </div>

      {showTimer && (
        <span className="timerItem">
          <span className="icon mmt-clock" />
          <span className="endsInText">{isEndTime ? 'Ends In' : 'Starts In'}</span>
          <Timer startTime={startTime} endTime={endTime} timerStartTime={timerStartTime} />
        </span>
      )}
    </div>
  );
};

export default OfferCard;
